// 引入vue echart
import ECharts from 'vue-echarts'
import { use } from 'echarts/core'

// 手动引入模块减小打包体积
import { CanvasRenderer } from 'echarts/renderers'
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  ToolboxComponent,
} from 'echarts/components'
// 图表类型 如： LineChart为折线图
import { BarChart, LineChart, PieChart } from 'echarts/charts'
// 引入visualMap和markLine
import 'echarts/lib/component/visualMap'
import 'echarts/lib/component/markLine'
import 'echarts/lib/component/markPoint'
// 注册
use([
  CanvasRenderer,
  LegendComponent,
  GridComponent,
  TooltipComponent,
  ToolboxComponent,
  LineChart,
  BarChart,
  PieChart,
])

export default ECharts
